import React, { useState, useEffect, useMemo } from "react";
import api from "../../Services/api";
import MenuLateral from "../../Componentes/MenuLateral";
import ListaMotorista from "../../Componentes/ListaMotorista";
import { useNavigate } from "react-router-dom";
import { FaSearch } from "react-icons/fa";

import "./styles.css";

const SITUACAO_ATIVO = 1;
const SITUACAO_INATIVO = 2;

const Menu = () => {
  const [dadosMotorista, setdadosMotorista] = useState([]);
  const [filtro, setfiltro] = useState("");
  const [ordenacao, setOrdenacao] = useState("nome");
  const [situacaoFiltro, setSituacaoFiltro] = useState(SITUACAO_ATIVO);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("usuarioLogado") === null) {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    carregaListaMotorista(filtro);

    const intervaloMenu = setInterval(() => {
      carregaListaMotorista(filtro);
    }, 60000);

    return () => clearInterval(intervaloMenu);
  }, [filtro, situacaoFiltro]);

  async function carregaListaMotorista(busca) {
    const retorno = await buscaMotoristas(busca);

    if (retorno?.data) {
      const motoristasFiltrados = retorno.data.filter(
        (motorista) => Number(motorista.situacao) === situacaoFiltro
      );
      setdadosMotorista(motoristasFiltrados);
      return;
    }

    setdadosMotorista([]);
  }

  async function buscaMotoristas(busca) {
    try {
      const response = await api.get("/motoristas?filter=" + busca);
      return response;
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  const listaOrdenada = useMemo(() => {
    const lista = [...dadosMotorista];

    return lista.sort((a, b) => {
      if (ordenacao === "nome") {
        return a.nome.localeCompare(b.nome);
      }
      if (ordenacao === "idCarga") {
        return a.IDlote - b.IDlote;
      }
      if (ordenacao === "valorCarga") {
        return b.ValorEntregas - a.ValorEntregas;
      }
      if (ordenacao === "datahora") {
        return new Date(b.datahora) - new Date(a.datahora);
      }
      return 0;
    });
  }, [dadosMotorista, ordenacao]);

  const exibindoInativos = situacaoFiltro === SITUACAO_INATIVO;

  const resumo = useMemo(() => {
    return listaOrdenada.reduce(
      (acc, motorista) => {
        acc.totalCarga += Number(motorista.ValorEntregas || 0);
        acc.totalEntregue += Number(motorista.valorJaEntregue || 0);
        acc.totalParadas += Number(motorista.Nentregas || 0);
        return acc;
      },
      { totalCarga: 0, totalEntregue: 0, totalParadas: 0 }
    );
  }, [listaOrdenada]);

  const formatCurrency = (value) =>
    new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
      maximumFractionDigits: 2,
    }).format(value || 0);

  function alternarListaMotoristas() {
    setSituacaoFiltro((situacaoAtual) =>
      situacaoAtual === SITUACAO_ATIVO ? SITUACAO_INATIVO : SITUACAO_ATIVO
    );
  }

  return (
    <div className="menu-container-menu">
      <MenuLateral />

      <div id="painel_principal_menu">
        <div className="menu-page-header">
          <div className="menu-page-title">
            <div className="menu-page-title-row">
              <span className="motorista-page-kicker">Operacao</span>
              <h5 className="motorista-page-title" >Monitoramento de Entregas</h5>
            </div>
          </div>

          <button
            type="button"
            className="menu-switch-button"
            onClick={alternarListaMotoristas}
          >
            {exibindoInativos ? "Ver ativos" : "Ver inativos"}
          </button>
        </div>

        <div className="menu-summary-grid">
          <div className="menu-summary-card">
            <span>Motoristas na lista</span>
            <strong>{listaOrdenada.length}</strong>
            <small>{exibindoInativos ? "Status inativo" : "Status ativo"}</small>
          </div>
          <div className="menu-summary-card">
            <span>Valor total da carga</span>
            <strong>{formatCurrency(resumo.totalCarga)}</strong>
            <small>Soma da operacao exibida</small>
          </div>
          <div className="menu-summary-card">
            <span>Valor ja entregue</span>
            <strong>{formatCurrency(resumo.totalEntregue)}</strong>
            <small>Entrega confirmada ate o momento</small>
          </div>
          <div className="menu-summary-card">
            <span>Total de paradas</span>
            <strong>{resumo.totalParadas}</strong>
            <small>Baseado nas entregas planejadas</small>
          </div>
        </div>

        {exibindoInativos && (
          <h5 className="menu-status-alert">Lista de motoristas inativos</h5>
        )}

        <div id="div_painel_menu">
          <div className="menu-toolbar">
            <div className="form-group mb-3 menu-toolbar-field menu-toolbar-search">
              <label htmlFor="buscar" className="form-label">
                Filtro:
              </label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control form-control-lg"
                  id="buscar"
                  placeholder="Digite sua busca (Nome ou Placa)"
                  value={filtro}
                  onChange={(e) => setfiltro(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      carregaListaMotorista(e.target.value);
                    }
                  }}
                />
                <button
                  type="button"
                  className="btn btn-primary btn-lg menu-search-button"
                  onClick={() => carregaListaMotorista(filtro)}
                >
                  <FaSearch />
                </button>
              </div>
            </div>

            <div className="form-group mb-3 menu-toolbar-field menu-toolbar-sort">
              <label htmlFor="ordenacao" className="form-label">
                Ordenar por:
              </label>
              <select
                className="form-control"
                id="ordenacao"
                value={ordenacao}
                onChange={(e) => setOrdenacao(e.target.value)}
              >
                <option value="nome">Nome</option>
                <option value="idCarga">ID Carga</option>
                <option value="datahora">Data da Saida</option>
                <option value="valorCarga">Valor da Carga</option>
              </select>
            </div>
          </div>

          <ListaMotorista
            listaMotoriista={listaOrdenada}
            maxHeight="calc(100vh - 235px)"
          />
        </div>
      </div>
    </div>
  );
};

export default Menu;
